import { MoreHoriz, Pause, PlayArrow } from "@mui/icons-material"
import { Tooltip, useTheme } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { getCurrentRandomAlbum, getRandomModeActive } from "../../reducers/randomMode"
import ContextualActivator from "../contextMenus/ContextualActivator"
import { setRandomModeActive } from "../../actions/randomModeActions"
import { anyLongDisablingProcess } from "../../reducers/disablingProcesses"
import { useRandomModeStartingResumingActions } from "../../hooks/randomMode/useRandomModeStartingResumingActions"
import ContainedIconButton from "../common/buttons/ContainedIconButton"
import SubContainedIconButton from "../common/buttons/SubContainedIconButton"

const RandomModeStartButton = ({emptyQueue}) => {
    const randomModeActive = useSelector(getRandomModeActive);
    const currentRandomAlbum = useSelector(getCurrentRandomAlbum);

    const { availableActions, mainStartingAction, mainResumingAction } = useRandomModeStartingResumingActions();

    const disabled = useSelector(anyLongDisablingProcess) || emptyQueue;

    const theme = useTheme();
    const dispatch = useDispatch();

    const onClickMainButton = () => {
        // If the random mode is active
        if(randomModeActive) {
            // It is paused
            pauseMode();
            return;
        }

        // If the random mode is not active but it is paused
        if(currentRandomAlbum) {
            // The resuming action chosen by the user (or the default one if the user choice is not available) is performed
            mainResumingAction.onClick();
            return;
        }

        // In any other case, the random mode will be started since it is stopped
        // The starting action chosen by the user (or the default one if the user choice is not available) is performed
        mainStartingAction.onClick();
    }

    const pauseMode = () => {
        dispatch(setRandomModeActive(false));
    }

    return (
        <div className="relative-position">
            <ContextualActivator
                contextMenuOptions={availableActions}
                onClickLeft={false}
                disabled={disabled}
            >
                <Tooltip title={randomModeActive ? "Pause random mode" : currentRandomAlbum ? mainResumingAction.text : mainStartingAction.text}>
                    <span>
                        <ContainedIconButton disabled={disabled} themeColor={theme.palette.primary} onClick={onClickMainButton}>
                            { randomModeActive ? <Pause /> : <PlayArrow /> }
                        </ContainedIconButton>
                    </span>
                </Tooltip>
            </ContextualActivator>
            {
                !randomModeActive &&
                <ContextualActivator
                    contextMenuOptions={availableActions}
                    onClickLeft={true}
                    disabled={disabled}
                >
                    <Tooltip title={currentRandomAlbum ? "More options for resuming random mode" : "More options for starting random mode"}>
                        <span>
                            <SubContainedIconButton disabled={disabled} themeColor={theme.palette.secondary}>
                                <MoreHoriz />
                            </SubContainedIconButton>
                        </span>
                    </Tooltip>
                </ContextualActivator>
            }
        </div>
    )
}

export default RandomModeStartButton;